<app-loader></app-loader>
<router-outlet></router-outlet>
<app-host-modal [modals]="modals$ | async"></app-host-modal>
<toaster-container [toasterconfig]="toasterConfig"></toaster-container>
